import type { Residency } from "@esi/shared";
import { Globe, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * A short factual note of where data is stored and models run, for the value the API resolved
 * (the project's, or the user's scope on home). Without a value, nothing: the app never guesses.
 */
export function ResidencyNote(props: {
  value: Residency | null | undefined;
  /** The agent may run code here: the note also says where (data-residency, agent-turn D14). */
  codeExecution?: boolean | undefined;
  className?: string;
}) {
  const { t } = useTranslation();
  if (props.value !== "eu" && props.value !== "global") {
    return null;
  }
  const Icon = props.value === "global" ? Globe : MapPin;
  const long = props.value === "global" ? t("residencyNote.globalLong") : t("residencyNote.euLong");
  const code = props.codeExecution
    ? props.value === "global"
      ? t("residencyNote.codeGlobal")
      : t("residencyNote.codeEu")
    : null;
  return (
    <p
      className={cn("inline-flex items-center gap-1.5 text-xs text-fg-muted", props.className)}
      title={code ? `${long} ${code}` : long}
    >
      <Icon aria-hidden="true" className="size-3.5 shrink-0" strokeWidth={1.75} />
      <span>
        <span className="sr-only">{t("residencyNote.label")}: </span>
        {props.value === "global" ? t("residencyNote.global") : t("residencyNote.eu")}
        {code && <span className="sr-only">. {code}</span>}
      </span>
    </p>
  );
}
